import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useScreenSize = () => {
  const theme = useTheme();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let breakpoint = 'unknown';
  if (isXs) breakpoint = 'xs';
  if (isSm) breakpoint = 'sm';
  if (isMd) breakpoint = 'md';
  if (isLg) breakpoint = 'lg';
  if (isXl) breakpoint = 'xl';

  return { windowWidth, breakpoint };
};
